type GoToTopOptions = {
  target?: string;
  threshold?: number;
  visibleClass?: string;
};

export function initGoToTopButton(): void {
  const nodes = document.querySelectorAll<HTMLElement>('[data-goToTop]');
  if (!nodes || nodes.length === 0) return;

  nodes.forEach((el) => {
    let options: GoToTopOptions = {};
    try {
      const raw = el.getAttribute('data-goToTop');
      if (raw) options = JSON.parse(raw);
    } catch (err) {
      // malformed JSON — silently ignore and use defaults
    }

    const threshold = typeof options.threshold === 'number' ? options.threshold : 200;
    const visibleClass = options.visibleClass || 'go-to-top--visible';

    const onScroll = (): void => {
      if (window.scrollY > threshold) {
        el.classList.add(visibleClass);
      } else {
        el.classList.remove(visibleClass);
      }
    };

    // initial state
    onScroll();

    window.addEventListener('scroll', onScroll, { passive: true });

    el.addEventListener('click', (ev) => {
      ev.preventDefault();
      const targetSelector = options.target;
      if (targetSelector) {
        const targetEl = document.querySelector(targetSelector) as HTMLElement | null;
        if (targetEl && 'scrollTo' in targetEl) {
          try {
            (targetEl as any).scrollTo({ top: 0, behavior: 'smooth' });
            return;
          } catch (e) {
            // fallback to window
          }
        }
      }

      window.scrollTo({ top: 0, behavior: 'smooth' });
    });
  });
}

initGoToTopButton();
